import React from 'react';
import TemplateDefault from "../components/template-default";

const Loading = () => {
    return (
        <TemplateDefault title="">
            <div className="flex items-center justify-center h-full w-full">
                <div className="inline-block h-52 w-52 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                    role="status">
                </div>
            </div>
        </TemplateDefault>
    );
};

export default Loading;